import {saveProductCombo} from '@/services/ProductComboService/productComboService'
import {transformComboSaveRequest} from '@/utils/productCombo/transformComboDetailResponse'
import {useMutation} from '@tanstack/react-query'

export const PRODUCT_COMBO_SAVE_MUTATION_KEY = 'product-combo-save'

/**
 * Creates a reusable mutation for saving a product combo.
 * @param {import('@tanstack/react-query').UseMutationOptions<any, Error, import('@/types/productComboTypes').ProductCombo>} [options] - Optional react-query mutation options.
 * @returns {import('@tanstack/react-query').UseMutationResult<any, Error, import('@/types/productComboTypes').ProductCombo>} Product combo save mutation.
 */
export const useSaveProductCombo = options => {
  return useMutation({
    ...options,
    mutationKey: [PRODUCT_COMBO_SAVE_MUTATION_KEY],
    mutationFn: productComboData => saveProductCombo(transformComboSaveRequest(productComboData)),
  })
}
